import { commonFiltersAndTeamAgent } from '../../automation/constants/filters';

export const BULK_ACTION_FILTERS = commonFiltersAndTeamAgent;
